import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Col, Form, Label } from 'reactstrap'
import { Form as ReduxForm, actions } from 'react-redux-form'
import { withLang } from '../../utils/withLang'
import LineAwesome from '../../components/LineAwesome'
import SelectEmailTemplate from '../../components/SelectEmailTemplate'
import SelectMessageType from '../../components/SelectMessageType'
import SelectClub from '../../components/SelectClub'
import SelectBoolean from '../../components/SelectBoolean'
import SelectAgeGroup from '../../components/SelectAgeGroup'
import { toast } from 'react-toastify'
import { sendCampaignMen, sendCampaignWomen } from '../../redux/actions/ageGroupActions'

class CampaignsForm extends Component {
  handleChange = field => value => {
    this.props.dispatch(actions.change(`forms.emailCampaign.${field}`, value))
  }

  handleSend = gender => {
    const { form, lang, dispatch } = this.props

    const {
      age_group: ageGroupId,
      email_template: emailTemplateId,
      message_type: messageTypeId,
      club: clubId,
      is_campaign_travel_abroad_interested: isCampaignTravelAbroadInterested,
      is_campaign_family_travel_interested: isCampaignFamilyTravelInterested,
    } = form || {}

    if (!ageGroupId || !emailTemplateId) {
      toast.warn(lang.errors.required_field)
      return
    }

    const action = gender === 'women' ? sendCampaignWomen : sendCampaignMen
    dispatch(
      action(
        ageGroupId,
        emailTemplateId,
        messageTypeId,
        clubId,
        isCampaignTravelAbroadInterested,
        isCampaignFamilyTravelInterested
      )
    )
  }

  render() {
    const { lang, form } = this.props

    return (
      <Form model="forms.emailCampaign" tag={ReduxForm}>
        <div className="card-body">
          <h4>{lang.send_campaign}</h4>
          <hr />
          <div className="row">
            <Col md={6}>
              <Label>{lang.age_group}</Label>
              <SelectAgeGroup
                value={form.age_group}
                onChange={this.handleChange('age_group')}
              />

              <Label>{lang.email_template}</Label>
              <SelectEmailTemplate
                value={form.email_template}
                onChange={this.handleChange('email_template')}
              />

              <Label>{lang.followup_message_templates} ({lang.not_mandatory})</Label>
              <SelectMessageType
                value={form.message_type}
                onChange={this.handleChange('message_type')}
              />

              <Label>{lang.club} ({lang.not_mandatory})</Label>
              <SelectClub
                value={form.club}
                onChange={this.handleChange('club')}
              />
            </Col>
            <Col md={6}>
              <Label>{lang.campaign_travel_abroad_interested}</Label>
              <SelectBoolean
                value={form.is_campaign_travel_abroad_interested}
                onChange={this.handleChange('is_campaign_travel_abroad_interested')}
              />

              <Label>{lang.campaign_families_interested}</Label>
              <SelectBoolean
                value={form.is_campaign_family_travel_interested}
                onChange={this.handleChange('is_campaign_family_travel_interested')}
              />
            </Col>
          </div>

          <div className="row justify-content-center mt-4">
            <Button color="warning" className="mr-2" onClick={() => this.handleSend('women')}>
              <LineAwesome icon="bullhorn" className="flip-horizontal"/> {lang.send_campaign_for_age_group_women}
            </Button>
            <Button color="primary" onClick={() => this.handleSend('men')}>
              <LineAwesome icon="bullhorn" className="flip-horizontal"/> {lang.send_campaign_for_age_group_men}
            </Button>
          </div>
        </div>
      </Form>
    )
  }
}

const mapStateToProps = state => ({
  form: state.forms.emailCampaign,
})

export default connect(mapStateToProps)(withLang(CampaignsForm))
